import { render, staticRenderFns } from "./EventDataRenderer.vue?vue&type=template&id=1d737769"
import script from "./EventDataRenderer.vue?vue&type=script&lang=js"
export * from "./EventDataRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports